import { css } from '@emotion/css';

export const title03 = css`
  margin: 0;
  font-size: 18px;
  line-height: 27px;
`;